import { css, cx, useTheme } from '@fable/theme'
import { FlexBox, Logo, PageContainer, Text } from '@fable/components'
import { DownloadAppCardTestimonials } from './DownloadAppCardTestimonials'
import appPreview from '../../../../assets/images/demo/fable-app-preview-row.webp'
import { DownloadAppCardActions } from './DownloadAppCardActions'

export const DownloadAppCard: React.VFC<{ className?: string }> = ({
  className,
}) => {
  const { colors, mediaQueries } = useTheme()

  return (
    <PageContainer
      card
      data-testid="downloadAppCard"
      id="app-download"
      className={cx(
        css`
          padding: 0 16px;
          background-color: ${colors.uiPinkLight};
          border-radius: 0;
          ${mediaQueries.tablet} {
            padding: 0 40px;
            border-radius: 12px;
          }
        `,
        className
      )}
    >
      <FlexBox
        className={css`
          padding-top: 66px;
          flex-direction: column;
          align-items: center;
          ${mediaQueries.tabletL} {
            padding-top: 0;
          }
          ${mediaQueries.desktop} {
            margin: 0 auto;
            max-width: 1228px;
            width: 100%;
            flex-direction: row;
            justify-content: space-between;
            align-items: flex-end;
          }
        `}
      >
        <div
          className={css`
            margin-bottom: 12px;
            width: 100%;
            flex-shrink: 0;
            ${mediaQueries.mobileL} {
              margin-bottom: 0;
            }
            ${mediaQueries.tabletL} {
              padding-top: 96px;
            }
            ${mediaQueries.desktop} {
              margin-right: 40px;
              padding: 60px 0;
              max-width: 378px;
            }
            ${mediaQueries.desktopL} {
              margin-right: 40px;
            }
          `}
        >
          <FlexBox
            className={css`
              margin: 0 auto;
              padding: 48px 8px;
              background-color: ${colors.uiPinkExtraLight};
              border-radius: 24px;
              text-align: center;
              width: 100%;
              max-width: 500px;
              ${mediaQueries.desktop} {
                padding: 0;
                background-color: transparent;
              }
            `}
            flexDirection="column"
            centerAll
          >
            <FlexBox
              className={css`
                width: 56px;
                height: 56px;
                border-radius: 12px;
                background-color: ${colors.blackSwan};
              `}
              centerAll
            >
              <Logo isIcon />
            </FlexBox>
            <Text
              className={css`
                margin: 24px 0 20px;
                ${mediaQueries.tablet} {
                  margin: 25px 0 28px;
                }
              `}
              tag="h3"
              type="subhead"
              sizing={{ base: 'XS', mobileXS: 'L', tablet: 'XL' }}
            >
              Find your community.
              <br />
              Get the app, join a book club.
            </Text>
            <DownloadAppCardActions />
          </FlexBox>
          <DownloadAppCardTestimonials />
        </div>
        <img
          className={css`
            margin-top: 24px;
            display: block;
            width: 100%;
            max-width: 800px;
            ${mediaQueries.desktop} {
              max-width: none;
              width: 900px;
            }
          `}
          src={appPreview}
          alt="row of fable app previews"
        />
      </FlexBox>
    </PageContainer>
  )
}
